<template>
<v-app>
    <div class="app">
        <div class="hero_img">
        <div class="absolute pa-20">
            <div class="navbar">
                <a>
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/ude_logo.png"  >
                    </v-btn>
                </a>
                <a href="#" class="nav_title">{{ $t("ude.website") }}</a>
                <a href="http://www.ebmtech.com/en/about/index.php" target="_blank" class="sm-none">About Us</a>
                <a href="http://www.ebmtech.com/en/contact/index.php" target="_blank" class="sm-none">Contact Us</a>
            <div class="float-r mr-30"> 
                <a href="https://www.facebook.com/ebmtech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/fb.png" >
                    </v-btn>
                </a>
                <a href="https://www.linkedin.com/company/14425711/admin/" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/li.png" >
                    </v-btn>
                </a>
                <a href="https://twitter.com/EBM_Tech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/tw.png" >
                    </v-btn>
                </a>
                <a href="https://www.youtube.com/c/Ebmtech" target="_blank" class="xs-none">
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/yt.png" >
                    </v-btn>
                </a>
                <a href="https://apps.apple.com/dk/app/ude-lite/id596265500?l" target="_blank" class="outline">Download</a>
                <!-- <v-btn class="mr-1" icon @click="language" style="margin-right:5px">
                <p style="font-size:18px; margin-top:10px">{{langval}}</p>
                </v-btn> -->
            </div>
            </div>
            <div class="hero_content">
                <p class="hero_title">UDE</p>
                <p class="hero_subtitle">Server. Viewer. Display. AI All in one iPad</p>
                <div class="blue_button" @click="dialog=true">
                    <p class="blue_button_content" >Sign up for <span style="font-weight: bold;">2 months FREE </span> trial</p>
                </div>
                <img data-aos="fade-up" data-aos-duration="3000" src="@/assets/ude/hero_product 1.png" class="hero_image xs-none" >
                <img data-aos="fade-up" data-aos-duration="3000" src="@/assets/ude/phhero_img1.png" class="phhero_image" >
                <img data-aos="fade-up" data-aos-duration="3000" src="@/assets/ude/phhero_img2.png" class="phhero_image" >
            </div>
        </div>
        </div>
        <div class="middle_img">
            <div class="p-261">
            <v-row>
                <v-col cols="12" md="6" class="xrc1">
                    <img data-aos="fade-right" data-aos-duration="500" class="xrc_img1"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine" 
                        src="@/assets/ude/xrc1.png" >
                </v-col>
                <v-col cols="12" md="6">
                    <div class="pt-80 pl-96" data-aos="fade-up" data-aos-duration="500">
                        <p class="xrc-a">Comprehensive Viewing Tools</p>
                        <p class="xrc-b"> Provide users with intuitive interface for optimum viewing 
                            experience to satisfy the needs of radiologists and<br>
                            medical professionals as they view <br>
                            medical images on daily basis.</p>
                    </div>
                </v-col>
            </v-row>
            <div class="pt-45">
            <v-row >
                <v-col cols="12" md="6" class="xrc2_desktop">
                    <div class="pt-80" data-aos="fade-up" data-aos-duration="500" style="justify:right">
                        <p class="xrc-a">AI Gateway</p>
                        <p class="xrc-b">Enable both edge and cloud computing capabilities to<br>
                            visualize AI inference on images for aid in the diagnosis<br>
                            or detection for diseases.</p>
                    </div>
                </v-col>
                <v-col cols="12" md="6" class="xrc2_img">
                    <img data-aos="fade-left"  class="xrc_img1 fr"
                        data-aos-offset="300" data-aos-duration="500"
                        data-aos-easing="ease-in-sine" 
                        src="@/assets/ude/xrc2.png" >
                </v-col>
                <v-col cols="12" md="6" class="xrc2_phone">
                    <div class="pt-80" data-aos="fade-up" data-aos-duration="500" style="justify:right">
                        <p class="xrc-a">AI Gateway</p>
                        <p class="xrc-b">Enable both edge and cloud computing capabilities to<br>
                            visualize AI inference on images for aid in the diagnosis<br>
                            or detection for diseases.</p>
                    </div>
                </v-col>
            </v-row>
            </div>
            <div class="pt-80">
            <v-row>
                <v-col cols="12" md="6" class="xrc3">
                    <img data-aos="fade-right" data-aos-duration="500" class="xrc_img1"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine" 
                        src="@/assets/ude/xrc3.png" >
                </v-col>
                <v-col cols="12" md="6">
                    <div class="pt-80 pl-96" data-aos="fade-up" data-aos-duration="500">
                        <p class="xrc-a">Custom Mammo Hanging Protocol</p>
                        <p class="xrc-b"> Allow radiologists to identify and assess reliable breast <br>
                            cancer screening and outcomes through customizable <br>
                            hanging protocol settings.</p>
                    </div>
                </v-col>
            </v-row>
            </div>
            </div>
            <div class="pt-221">
                <v-row>
                    <v-col cols="12" md="4"><div class="center mb-40p">
                        <img src="@/assets/ude/update.png"  >
                        <p class="service_title">Easy Update  </p>
                        <p class="service_subtitle">If the app requires update, you can simply 
                            update it through Apple App Store. </p></div>
                    </v-col>
                    <v-col cols="12" md="4"><div class="center mb-40p">
                        <img src="@/assets/ude/replace.png" >
                        <p class="service_title">Easy Replacement  </p>
                        <p class="service_subtitle">If the device breaks down, 
                            you can simply replace it by getting
                            a new iPad at any Apple authorized dealer. </p></div>
                    </v-col>
                    <v-col cols="12" md="4"><div class="center mb-40p">
                        <img src="@/assets/ude/backup.png" >
                        <p class="service_title">Easy Data Backup  </p>
                        <p class="service_subtitle">All image data stored in UDE
                             can be backup to cloud-based servers or any compatible NAS. </p></div>
                    </v-col>
                </v-row>
            </div>
            <p class="service2_title" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">How UDE is BETTER?</p>
            <div class="pt-60 p-261">
                <v-row class="ph_center">
                    <v-col cols="12" md="4">
                        <p class="flow-t" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">The UDE APP work flow</p>
                        <img src="@/assets/ude/flow1.png" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" class="wf_img" >
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="center">
                            <img src="@/assets/ude/tick.png" class="wf" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" >
                            <p class="flow-ul" data-aos="fade-up" data-aos-duration="500" data-aos-delay="1000" >Mobility</p>
                            <img src="@/assets/ude/tick.png" class="wf" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">
                            <p class="flow-ul" data-aos="fade-up" data-aos-duration="500" data-aos-delay="1000" >Flexibility</p>
                            <img src="@/assets/ude/tick.png" class="wf" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">
                            <p class="flow-ul" data-aos="fade-up" data-aos-duration="500" data-aos-delay="1000">Edge Computing</p>
                            <p class="wf" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">Low</p>
                            <p class="flow-ul" data-aos="fade-up" data-aos-duration="500" data-aos-delay="1000">Replacement Cost</p>
                            <p class="wf" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">Low</p>
                            <p class="flow-ul" data-aos="fade-up" data-aos-duration="500" data-aos-delay="1000">Set Up Cost</p>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4"><div class="center">
                        <p class="flow-t p-62" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">PACS work flow</p>
                        <img src="@/assets/ude/flow2.png" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" class="wf_img" ></div>
                    </v-col>
                </v-row>
            </div>
            <div class="center-t">
               <a href="https://apps.apple.com/dk/app/ude-lite/id596265500?l" target="_blank">
                <img src="@/assets/ude/mid_banner.png" class="banner xs-none" >
                <img src="@/assets/ude/phbanner.png" class="phbanner" >
                </a>
            </div>
        </div>
        <p class="service2_title pb-56 mtt-110">What makes the UDE APP Unique?</p>
        <div class="h-507">
            <tabs class="p-125"
            :tabs="tabs"
            :currentTab="currentTab"
            :wrapper-class="'default-tabs'"
            :tab-class="'default-tabs__item'"
            :tab-active-class="'default-tabs__item_active'"
            :line-class="'default-tabs__active-line'"
            @onClick="handleClick"
            />
            <div class="content">
            <div v-if="currentTab === 'tab1'" class="swipe">
                <v-row class="slide">
                    <v-col cols="12" md="6">
                        <div class="center">
                        <img class="tab_img" src="@/assets/ude/tabs1.png"></div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <p class="tab_t">Calibration</p>
                        <p class="tab_st">The UDE App comes with an in-house designed calibration procedure
                             that works with an external luminance meter manufactured by the third-party 
                             vendor. The calibration complies with the AAPM protocol and ensures any display 
                             of iPad Pro follows the DICOM Curve.</p>
                    </v-col>
                </v-row>
            </div>
            <div v-if="currentTab === 'tab2'" class="swipe">
                <v-row class="slide">
                    <v-col cols="12" md="6">
                        <div class="center">
                        <img class="tab_img" src="@/assets/ude/tabs2.png"></div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <p class="tab_t">Reporting System</p>
                        <p class="tab_st">While traveling, doctors and medical professionals can 
                            complete their reports by using the AgileRIS, the app-based reporting 
                            system designed by EBM specifically for the UDE App. The reporting app 
                            connects with any Radiology Information System (RIS) to enable the ability
                            for exam images and list of report to be pre-downloaded on iPad. Both the 
                            images and the list are saved locally for offline access.</p>
                    </v-col>
                </v-row>
            </div>
            <div v-if="currentTab === 'tab3'">
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="center">
                        <img class="tab_img" src="@/assets/ude/tabs3.png">
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <p class="tab_t">AI-Ready Platform</p>
                        <p class="tab_st">Turn the conventional referral procedure into completely CD-less
                             solution with DICOM image files sent directly to your mobile devices.
                             (Allow patients to view/share medical images easily without a physical disk 
                             and facilitate hospitals/clinics transferal procedures.)</p>
                    </v-col>
                </v-row>
            </div>
            <div v-if="currentTab === 'tab4'">
                <v-row>
                    <v-col cols="12" md="6">
                        <div class="center">
                        <img class="tab_img" src="@/assets/ude/tabs4.png"></div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <p class="tab_t">Alternative of CD Burning</p>
                        <p class="tab_st">The UDE App changes the conventional referral procedure 
                            into completely CD-less with DICOM image files being sent directly to mobile 
                            device through either AirDrop (iOS only) or QR Code. The feature help facilitate 
                            the teleconsultation process between doctor and doctor while fulfilling the goal 
                            of reducing CD emissions.</p>
                    </v-col>
                </v-row>
            </div>
            </div>
        </div>
        <div class="brain_img">
            <p class="brain_t">Certification & Awards</p>
            <div class="desktop">
            <div v-if="certificate">
            <div class="rev_center">
                <div class="xs-center inline">
                <img class="cert_img " src="@/assets/ude/certificateUde.png">
                </div>
                <div class="inline fda">
                    <img class="fdalogo" src="@/assets/ude/fdalogo.png">
                    <p class="fda-t1">The UDE App displays images from CT, MR, CR, US, XA and SC for the trained
                         physician’s diagnosis or referring purpose. </p>
                    <p class="fda-t3">*The UDE App is not to be used for mammography diagnosis. </p>
                </div>
                <div class="inline fda-cir">
                    <div class="circle" @click="certificate=!certificate">
                        <img class="ptt-16" src="@/assets/ude/right_arrow.png">
                    </div>
                </div>
            </div>
            </div>
            <div v-else>
            <div class="rev_center">
                <div class="inline fda-cir2">
                    <div class="circle" @click="certificate=!certificate">
                        <img class="ptt-16" src="@/assets/ude/left_arr.png">
                    </div>
                </div>
                <div class="inline">
                <img class="cert_img2" src="@/assets/ude/awardsUde1.png">
                </div>
                <div class="inline fda">
                    <a href="https://edisonawards.com/winners2021.php" target="_blank"><img class="fdalogo" src="@/assets/ude/edison_logo.png"></a>
                    <a href="https://innovationaward.org/" target="_blank"><img class="inofdalogo" src="@/assets/ude/innologo.png"></a>
                    <p class="fda-t3  w-465">Ubiquitous Diagnostic Environment (UDE) App has received numerous awards and recognition throughout the years, including the 2021 Edison Awards, the 2021 International Innovation Awards (IIA) and the 2021 National Innovation Awards.</p>
                   <!-- <a href="https://edisonawards.com/winners2021.php" target="_blank"><p class="fda-t2">Find out more ></p></a> -->
                </div>
            </div>
            </div>
            </div>
            <div class="xs-block">
                <div class="xs-center inline">
                <img class="cert_img" src="@/assets/ude/certificateUde.png">
                </div>
                <div class="fda">
                    <img class="fdalogo" src="@/assets/ude/fdalogo.png">
                    <p class="fda-t1  w-465">The UDE App displays images from CT, MR, CR, US, XA and SC for the trained
                         physician’s diagnosis or referring purpose. </p>
                    <!-- <p class="fda-t2">Find out more ></p> -->
                    <p class="fda-t3">*The UDE App is not to be used for mammography diagnosis. </p>
                </div>
                <img class="cert_img2" src="@/assets/ude/awardsUde1.png">
                <div class=" fda">
                    <a href="https://edisonawards.com/winners2021.php" target="_blank"><img class="fdalogo" src="@/assets/ude/edison_logo.png"></a>
                    <a href="https://innovationaward.org/" target="_blank"><img class="inofdalogo" src="@/assets/ude/innologo.png"></a>
                    <!-- <p class="fda-t1">2021 Edison Awards </p> -->
                    <p class="fda-t3  w-465">Ubiquitous Diagnostic Environment (UDE) App has received numerous awards and recognition throughout the years, including the 2021 Edison Awards, the 2021 International Innovation Awards (IIA) and the 2021 National Innovation Awards.</p>
                    <!-- <a href="https://edisonawards.com/winners2021.php" target="_blank"><p class="fda-t2">Find out more ></p></a> -->
                </div>
            </div>
        </div>
        <!-- <div class="review">
            <div class="inline">
            <p class="review_t absolute">Positive Reviews</p></div>
            <div class="inline absolute center">
                <img class="revlogo" src="@/assets/ude/review.png">
                <p class="rev-t">Dr. Wang</p>
                <p class="rev-st">This product is so helpful. Would recommended to doctors who ....</p>
            </div>
        </div> -->
        <div class="explore">
            <div class="center">
                <p class="exp-t">Explore the Potential of The UDE App </p>
                <p class="exp-st"> We’ve seen the UDE app being used in various scenarios, helping medical 
                    professionals to stay efficient and to create more values. The UDE App is 
                    not intended to replace a full diagnostic workstation or system but to be a
                     value-added option.</p>
            </div>
            <div class="p-131">
            <v-row>
                <v-col cols="12" md="6" lg="3" ><div class="center">
                    <img src="@/assets/ude/exp_img1.png">
                    <p class="exp-c ">Mobile Clinics</p></div>
                </v-col>
                <v-col cols="12"  md="6" lg="3"  ><div class="center">
                    <img src="@/assets/ude/exp_img2.png" >
                    <p class="exp-c ">Emergency</p></div>
                </v-col>
                <v-col cols="12" md="6" lg="3" ><div class="center">
                    <img src="@/assets/ude/exp_img3.png">
                    <p class="exp-c">Conference</p></div>
                </v-col>
                <v-col cols="12" md="6" lg="3" ><div class="center">
                    <img src="@/assets/ude/exp_img4.png">
                    <p class="exp-c">Telemedicine</p></div>
                </v-col>
            </v-row>
            </div>
            <p class="center faq-h"> FAQ</p>
            <v-expansion-panels accordion class="p-212" dark> 
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q1: With an iPad Pro, Is there enough storage to store 
                    images?
                    How many images can be stored?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A1: The internal storage is provided based on the hardware (iPad Pro) specifications. 
                Currently, iPad Pros can support up to 1 TB storage; users can make the purchase based on their 
                demands. Taking "Mammography (MG) images" as an example, users can store approximately 10,000 MG 
                images based on the calculation of the formula (26MB/frames*4 frames/studies) on average. *The 
                number of images will vary based on the modality types and the storage occupied by OS and apps. </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q2: Could I use Samsung or other Android OS tablets instead of Apple iPads for the UDE app?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A2: Currently, the UDE App is only supported by iOS. Android support is still under development. </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q3: Is it required to use iPad Pro for the UDE app?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A3: Yes. We suggest using iPad Pros for the UDE app since they are inherently designed with 5.6 MP image resolution.
                 Based on the industry standard, 5 MP image resolution is required to display MG images for diagnosis purposes. </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q4: What's the difference between the UDE app and the iDO Viewer app?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A4: The UDE app turns iPad Pro into a standalone DICOM server, viewer and display, meaning all 
                DICOM image files are stored locally on the device, whereas iDO Viewer or other DICOM viewers 
                generally require a connection with an external server. The UDE app allows access to the images 
                completely offline, no delay.  </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q5: How are images transfered between the UDE app and multiple modalities/PACS?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A5: The UDE app supports image transmission based on the DICOM 3.0 standard. Users only need
                 to complete AE Title, Port, and IP settings on modalities/DICOM Server/PACS to enable DICOM 
                 communication with UDE.</v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header class="faq-q">Q6: The UDE app can support uploading images to the cloud
                     for sharing purposes; should information security issues be considered?</v-expansion-panel-header>
                <v-expansion-panel-content class="faq-q">
                A6: The UDE app not only encrypts image data for data protection but also uses SSL encryption procedures 
                for image transmission. In addition, the encrypted symbols are added behind the downloading links ; thus,
                 users are required to enter 4-digit verification codes to be able to download thier images. </v-expansion-panel-content>
            </v-expansion-panel>
            <div v-if="!learn_more" style="width:100%">
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q7: How does the UDE app ensure patient privacy and data security?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A7: The UDE app inherently encrypts image data for data protection. Furthermore, the SSL encryption 
                    procedure is required when the app performs query/retrieves with PACS or multiple modalities via 
                    DICOM communication. EBM Technologies comply with the policies or rules relevant with information
                    security and data protection, manage clinical data based on the data security principles from hospitals, 
                    and conduct a scan of all the data for systems regularly.</v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q8: Inputting medical record numbers (MRNs) to query images is troublesome. Does the UDE app work with barcode scanner?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A8: Barcode scanner currently is not supported on the UDE app. </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q9: Can the UDE app be integrated with the hospita RIS, allowing radiologists to dictate reports?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A9: Unfortunately, the UDE app may not work with your original report system , but we've developed 
                    an offline-enabled reporting application---the AgileRIS app (integration with the hospital RIS is required) specifically for it. 
                    In the future, we are planning to develop a simple reporting system built in the UDE app. </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q10: Can users view images on the UDE App through their own laptop/PC?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A10: Currently, images can only be reviewed through the UDE App. </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q11: What's the price of the UDE App? Is it based on the number of licenses sold?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A11: The UDE app can be downloaded via the App Store for free and offer a subscription plans on a monthly basis for USD $29.99, or annual license for USD $10,000.</v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header class="faq-q">Q12: Currently, most people are still accustomed to using personal computers; how to change healthcare professionals habits of using PCs?</v-expansion-panel-header>
                    <v-expansion-panel-content class="faq-q">
                    A12: The UDE app is intended to replace traditional workstations, but to provide doctors with on-the-go image browsing experiences even without internet access. Compared with other mobile DICOM viewer apps,
                    the UDE app enables users to store images into iPad Pros and view images offline. 
                    Therefore, UDE is more efficient, convenient, and advantageous. </v-expansion-panel-content>
                </v-expansion-panel>
            </div>
            <p class="center cblue" v-if="learn_more" @click="click_learn_more"> Learn more ></p>
            <p class="center cblue" v-else @click="click_learn_more"> Show less ></p>
            </v-expansion-panels>
            <ude-contact-form></ude-contact-form>
            <div class="navbar xs-block center">
            <div class="float-rr mr-30"> 
                <a href="https://www.facebook.com/ebmtech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/fb.png" >
                    </v-btn>
                </a>
                <a href="https://www.linkedin.com/company/14425711/admin/" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/li.png" >
                    </v-btn>
                </a>
                <a href="https://twitter.com/EBM_Tech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/tw.png" >
                    </v-btn>
                </a>
                <a href="https://www.youtube.com/c/Ebmtech" target="_blank" >
                    <v-btn icon class="icon">
                        <img src="@/assets/ude/yt.png" >
                    </v-btn>
                </a>
            </div>
            </div>
        </div>
        <div class="footer">
            <p class="footer-h center"> 2021 EBM Technologies. All Rights Reserved.</p>
        </div>
    </div>
    <v-dialog max-width="920"
      v-model="dialog">
      <div class="thankyou">
          <v-btn color="white" icon style="float:right; margin:20px; " 
             large
            @click="dialog=false">
        <v-icon>mdi-close</v-icon>
        </v-btn>
          <ude-contact-form></ude-contact-form>
      </div>
    </v-dialog>
</v-app>
</template>
<script>
import Tabs from 'vue-tabs-with-active-line';
import UdeContactForm from './UdeContactForm.vue';
export default {
  components: {
    Tabs,
    UdeContactForm,
    },
    metaInfo() {
        return { 
            title: "UDE",
            meta: [
                { name: 'description', content:  'Server. Viewer. Display. AI All in one iPad'},
            ]
        }
    },
    created(){
        let lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
        if(lang =='en'){
                this.$i18n.locale = 'en'
            localStorage.setItem('lang','en')
            this.lang = 'en'
        }else {
            console.log("chinese");
            this.$i18n.locale = 'ch'
            localStorage.setItem('lang','ch')
            this.lang = 'ch'
        }
    },
  data:function(){
        const lang = localStorage.getItem('lang')
        return{
            lang:lang,
            langval:'',
        tabs: [
        { title: 'Calibration', value: 'tab1' },
        { title: 'Reporting System', value: 'tab2' },
        { title: 'AI-Ready Platform', value: 'tab3', },
        { title: 'Alternative of CD Burning', value: 'tab4', }
        ],
        currentTab: 'tab1',
        certificate: true,
        dialog: false,
        learn_more: true,
        }
  },
  methods: {
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    click_learn_more(){
        this.learn_more = !this.learn_more
    },
    language(){
            console.log(this.langval);
            
            if(this.langval=='EN'){
                this.$i18n.locale = 'en'
                localStorage.setItem('lang','en');
                this.langval='中'
            }
            else{
                this.$i18n.locale = 'ch'
                localStorage.setItem('lang','ch');
                this.langval='EN'
            }
            // window.location.reload()
        },
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600&display=swap');
* {
  font-family: Raleway;
}
.slide{
    transition: transform 0.4s ease, width 0.4s ease;
}
.app{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background: black;
}
p{
    color: white;
}
.rev_center{
    max-width: 1500px;
    margin: auto;
}
.theme--dark.v-expansion-panels .v-expansion-panel{
    background: transparent;
}
.xrc2_desktop{
    display: block;
}
.thankyou{
    margin:auto;
    max-width: 920px;
    background: #33373B;
    border-radius: 5px;
}
.v-tab{
    text-transform: capitalize;
}
.phbanner, .xrc2_phone, .xs-block, .phhero_image {
    display: none;
}
.float-r{
    float: right;
}
.pa-20{
    padding: 20px;
}
.inline{
    display: inline-block;
}
.fda-cir{
    float: right;
    padding-right: 130px;
    padding-top: 200px;
}
.revlogo{
    margin-top: 52px;
}
.fda-cir2{
    float: left;
    padding-left: 130px;
    padding-top: 160px;
}
.cblue{
    padding-top: 36px;
    cursor: pointer;
    color: #00B8F6;
}
.ptt-16{
    padding-top: 16px !important;
}
.cert_img{
    display: inline-block;
    padding-top: 50px;
    padding-left: 250px;
}
.wf{
    color: #00B8F6;
    float:left; 
    font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 28px;
    padding-top:15px;
}
.cert_img2{
    display: inline-block;
    padding-top: 50px;
    padding-left: 100px;
}
.faq-h{
    font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 38px;
padding-top: 160px;
}
.outline{
    border: 1.5px solid #FFFFFF;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 0.4rem;
}
.center{
    text-align: center;
}
.footer-h{
    padding-top: 16px;
    font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 16px;
}
.faq-q{
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;

}
.nav_title{
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
}
.icon{
    width: 34px;
    height: 34px;
}
.mr-30{
    margin-right: 20px;
}
.hero_content{
    width: 100%;
    text-align: center;
}
.hero_img {
  /* The image used */
  background-image: url("../assets/ude/hero_image1.png");
  height: 1272.87px;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  
  /* Needed to position the navbar */
  position: relative;
}
.w-465{
    width: 465px;
}
.fdalogo{
    padding-bottom: 18px;
}
.inofdalogo{
    padding-bottom: 18px;
    padding-left: 17px;
}
.pb-56{
    padding-bottom: 56px;
}
.brain_img{
  background-image: url("../assets/ude/brain_img.png");
  height: 600px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  
  /* Needed to position the navbar */
  position: relative;
}
.rev-t{
    font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 28px;
padding-top: 18px;
}
.rev-st{
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
padding-top: 6px;
}
.h-507{
    max-width: 1500px;
    margin: auto;
    height: 507px;
    background-color: black;
}
.circle {
    border-radius: 100%;
    height: 54px;
    width: 54px;
    text-align: center;
    margin-left: -20px;
    background: #00BEFF;
    cursor: pointer;
}
.fr{
    float: right;
}
.circle p {
	padding-top: 9px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
}
.middle_img {
  /* The image used */
  background-image: url("../assets/ude/middle_img.png");
  height: 2545px;
  /* overflow-x: hidden; */
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: -261px;
  
  /* Needed to position the navbar */
  position: relative;
}
.mtt-110{
    margin-top: 170px;
}
.absolute{
    position: absolute;
    width: 100%;
}
.pt-296{
    padding-top: 296px;
}
.brain_t{
    max-width: 1500px;
    margin: auto;
    font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 38px;
padding-top: 44px;
padding-left: 250px;
}
.flow-t{
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 28px;
}
.fda{
    padding-left: 73px;
}
.fda-t1{
    width: 501px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    padding-bottom: 8px;
}
.fda-t2{
    cursor: pointer;
    font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 19px;
padding-bottom: 17px;
color: #00B8F6;
}
.fda-t3{
    padding-bottom: 17px;
    font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 16px;
}
.navbar a {
  /* float: left; */
  color: #f2f2f2;
  text-align: center;
  margin: 1px 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 21px;
  transition: 0.5s;
}

.navbar a:hover {
  color: #002E81;
}
.swipe{
    transition: all 0.4s ease
}
.blue_button{
    cursor: pointer;
    border-radius: 5px;
    width: 306px;
    height: 44px;
    background: #00BEFF;
    margin: auto;
    margin-top: 31px;
    transition: 0.5s;
}
.blue_button:hover{
    background: #002E81;
}
.flow-ul{
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: #E5E5E5;
    padding-top: 15px;
}
.blue_button_content{
    padding-top: 8px;
    font-size: 18px;
    font-style: normal;
    font-weight: normal;
    color: #FFFFFF;}
.hero_title{
    font-size: 64px;
    line-height: 75px;
    font-style: normal;
    font-weight: 600;
    margin-top: 139px;
}
.hero_subtitle{
    font-weight: 500;
    font-size: 36px;
    line-height: 42px;
    width: 426px;
    margin:auto;
    margin-top: 9px;
}
.pt-80
{
    padding-top: 80px;
} 
.pl-96{
    padding-left: 96px;
}
.xrc-a{
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 33px;
}
.xrc-b{
    width: 570px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    padding-top: 16px;
}
.p-261{
    max-width: 1500px;
    margin: auto;
    padding: 261px 125px 0px 125px;
}
.p-212{
    max-width: 1500px;
    margin: auto;
    padding: 37px 125px 0px 125px;
}
.p-125{
    padding: 0px 125px 0px 125px;
}
.pt-45{
    padding-top: 45px;
}
.pt-80{
    padding-top: 80px;
}
.service_title{
    font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 28px;
text-align: center;
padding-top: 31px;
}
.service_subtitle{
    margin: auto;
    width: 219px;
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
text-align: center;
padding-top: 12px;
}
.pt-221{
    max-width: 1500px;
    margin: auto;
    padding-top: 221px;
}
.service2_title{
    text-align: center;
    font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 38px;
padding-top: 146px;
/* padding-bottom: 56px; */
}
.pt-60{
    padding-top: 60px;
}
.center-t{
    text-align:center;
    padding-top: 134px;
}
.review{
    height: 281px;
    background: #2F2F2F;
}
.explore{
    background-image: url("../assets/ude/end_img.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}
.footer{
    height: 47px;
    background: #2F2F2F;
    }
.tab_t{
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 33px;
    padding-top: 102px;
    }
.tab_st{
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    width: 500px;
    padding-top: 19px;
}
.tab_img{
    width: 542px;
    height: 361px;
    background: rgba(0, 190, 255, 0.05);
}
.review_t{
    font-style: normal;
    font-weight: 500;
    font-size: 72px;
    line-height: 85px;color: rgba(255, 255, 255, 0.2);
    padding-left: 50px;
    padding-top: 30px;
}
.exp-t{
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 38px;
    padding-top: 132px;
}
.exp-st{
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
width: 1005px;
margin: auto;
padding-top: 36px;
}
.p-131 {
    max-width: 1500px;
    margin: auto;
    padding: 38px 131px 0px 131px;
}
.exp-c{
    padding-top: 22px;
    font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 21px;
}
@media screen and (max-width: 1360px){
.hero_image{
    width: 710px;
}
.p-261{
    padding: 170px 65px 0px 65px;
}
.xrc_img1{
    width: 440px;
}
.pl-96{
    padding-left: 26px;
}
.pt-80{
    padding-top: 45px;
}
.xrc-b{
    width: 390px;
}
.service2_title{
    padding-top: 86px;
}
.pt-221{
    padding-top: 121px;
}
.wf_img{
    width: -webkit-fill-available;
}
.flow-ul{
    font-size: 20px;
}
.banner{
    width: 800px;
}
.middle_img{
    height: 2145px;
}

.tab_img{
    width: 342px;
    height: 261px;}
.tab_t{
    padding-top: 42px;
}

.h-507{
    height: 407px;
}
.fda-cir{
    padding-right: 30px;
}
.fda-cir2{
    padding-left: 30px;
}
.fda{
    padding-left: 30px;
}
.brain_t {
    padding-left: 50px;
}
.cert_img{
  padding-left: 50px;
}
.cert_img2{
    padding-top: 100px;
    padding-left: 50px;
    width: 400px;
}
.w-465{
    width: 365px;
}
.brain_img{
    height: 580px;
}
.review_t{
    font-size: 52px;
}
.revlogo{
    height: 62px;
    width: 62px;
}
.exp-t{
    padding-top: 52px;
}
.faq-h{
    padding-top: 52px;
}
}
@media screen and (max-width: 955px){
    .sm-none{
        display: none;
    }
    .middle_img {
    height: 3986px;
}
.banner{
    width: 600px;
}
.wf_img{
    width: 500px;
    text-align: center;
}
.flow-t{
    text-align: center;
}
.center-t{
    padding-top: 52px;
}
.h-507{
    height: 707px;
}
.p-212{
    padding: 0px;
}
.p-125{
    padding: 0px 15px 0px 15px;
}
.xrc1{
    text-align: center;
}
.xrc3{
    text-align: center;
}
.pl-96{
    padding-left: 0px;
    max-width: 440px;
    margin:auto;
}
.xrc-b{
    max-width: 440px;
    margin:auto;
}
.xrc-a{
    max-width: 440px;
    margin:auto;
    /* text-align: center; */
}
.xrc2_img{
    text-align: center;
    padding-top: 32px;
}
.xrc2_desktop{
    display: none;
}
.xrc2_phone{
    display: block;
}
.fr{
    float: none;
}
.ph_center{
    text-align: center;
}
.p-62{
    padding-top: 62px;
}
.tab_t{
    width: 440px;
    margin:auto;
}
.tab_img{
    width: 440px;
}
.tab_st{
    width: 440px;
    margin:auto;
}
.fda-t1{
    width: 301px;
}
.fda-t3{
    width: 301px;
}
.circle[data-v-2754073b] {
    border-radius: 100%;
    height: 34px;
    width: 34px;
    text-align: center;
    margin-left: -20px;
}
.ptt-16 {
    padding-top: 10px !important;
    height: 24px;
}
.cert_img2{
    width: 350px;
}
.review_t{
    font-size: 32px;
}
.exp-st{
    width: 550px;
}
}
@media screen and (max-width: 727px){
    .hero_image{
    width: 510px;
}
.mtt-110{
    margin-top: 0px;
}
.p-261 {
    padding: 0px 35px 0px 35px;
}
.banner {
    width: 500px;
}
.cert_img{
    width: 220px;
}
.cert_img2{
    width: 220px;
    padding-left: 20px;
}
.service2_title{
    padding-top: 0px;
    font-size: 28px;
}
.revlogo {
    margin-top: 92px
;
}
.exp-t{
    font-size: 28px;
}
.exp-st{
    width: 350px;
}
.review_t{
    font-size: 26px;
    padding-top: 0px;
}
.rev-st{
    font-size: 14px;
}
.middle_img{
    height: 3856px
;}
.fda-t1{
    width: 200px;
    font-size: 12px;
    line-height: 21px;
}
.fdalogo{
    padding: 0px;
    width: 70px;
}
.fda-cir{
    padding-right: 10px;
}
.fda-t3{
    width: 200px;
}
}
@media screen and (max-width: 548px){

.phbanner{
    display: block;
    width: 100%;
}
.hero_image{
    width: 410px;
}
.xs-none{
    display: none;
}
.mr-30{
    margin-right: 0px;
}
.hero_subtitle{
    width: 284px;
    margin: auto;
    font-size: 24px;
}
.hero_title{
    margin-top: 109px;
}
.hero_img {
  /* The image used */
  background-size: auto;
  background-image: url("../assets/ude/phhero_img.png");}
  .phhero_image{
    display: block;
    width: 260px;
height: 333px;
padding-top: 32px;
margin: auto;
}
.middle_img{
    height: 3456px;
    /* background: none ; */
    padding-top: 150px;
}
.col-12, .col-md-6{
padding: 0px;
}
.xrc_img1{
    width: 343px;
    margin-top: 35px;
}
.xrc-a{
    font-size: 24px;
    max-width: 343px;
    margin: 0px;
}
.xrc-b{
    max-width: 343px;
    margin: 0px;
}
.pt-80{
    padding-bottom: 25px;
    padding-top: 0px;
}
.mb-40p{
    margin-bottom: 40px;
}
.pt-221, .service2_title{
    padding-top: 65px;
}
.flow-t{
    font-size: 18px;
    padding-top: 43px;
}
.wf_img{
    width: 284.22px;
height: auto;
}
.flow-ul, .wf{
    font-size: 16px;
}
.tab_img{
    width: 285.26px;
height: 190px;
}
.tab_t, .tab_st{
    width: 257px;
}
.pb-56{
    padding-bottom: 0px;
}
.brain_img{
  background-image: url("../assets/ude/phbrain_img.png");
  height: 1268px;
}
.cert_img{
    text-align: center;
margin: auto;
width: 286px;
height: 370px;
padding-left: 42px;
}
.xs-center{
    text-align: center;
}
.fda-t1, .fda-t3, .rev_center{
    width: 301px;
    margin: auto;
}
.circle, .fda-cir, .fda-cir2{
    display: none;
}
.fda{
    padding: 30px 0px 0px 0px;
    width: 301px;
    margin: auto;
}
.xs-block{
    display: block;
}
.desktop{
    display: none;
}
.cert_img2{
    margin-top: 40px;
    height: 240px;
    width: 100%;
    padding: 0%;
}
.exp-t{
    font-size: 24px;
    width: 265px;
    margin: auto;
}
.p-131{
    margin-top: 12px;
    padding: 0px;
}
.explore{
    background-image: none;
    /* height: 3150px; */
    }
.float-rr{
    float: none;
    margin-bottom: 30px;
}
.brain_t{
    padding-bottom: 10px;
}
}
@media screen and (max-width: 391px){
.xrc_img1{
    width: 299px;
}
}
</style>